module.exports = __webpack_public_path__ + "static/media/chart1_data.45acbae8.csv";